import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useWMS2011_R01Store, { defaultWMS2011_R01Filter } from "./Store_WMS2011_R01";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { SubtotalControl } from "./components/SubtotalControl";
import { SearchSpacer } from "src/components/common/common";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

interface Props {}

export const SearchSection_WMS2011_R01 = ({}: Props) => {
    const {
        WMS2011_R01Filter, 
        setWMS2011_R01Filter,
    } = useWMS2011_R01Store();

    const {
        wmsCdList,    //  물류센터 공통코드
        warehouseCdList,      //  창고 공통코드
        itemGroupList,        //  품목그룹 공통코드
        brandCdList         //  브랜드 공통코드
    } = useCommonCodeStore();

    const { setCodeSearchModalProps } = useUiuxStore();

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [	
		{
			fieldName: 'itemCd',
			category: '품목코드',
			focusId: 'itemCd_search',
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			extraFilter: () => ({
				itemCd: WMS2011_R01Filter.itemCd || '',
				itemNm: WMS2011_R01Filter.itemNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: WMS2011_R01Filter,
		setEditData: setWMS2011_R01Filter,
		defaultData: defaultWMS2011_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS2011_R01_search'
	});

    return (
        <div className="w-full">
            <SearchSectionDoubleForm buttonText="조회" >
                {/* 물류센터 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="물류센터"
                    value={WMS2011_R01Filter.logicCenter}
                    optionList={wmsCdList}
                    onChangeValue={(v) =>
                        setWMS2011_R01Filter({ logicCenter: v === "all" ? "" : v, })
                    }
                />

                {/* 창고 선택 */}
                <SearchDropDownForm<WareHouseDto>
                    label="창고명"
                    value={WMS2011_R01Filter.warehouseCd}
                    optionList={warehouseCdList}
                    onChangeValue={(v) =>
                        setWMS2011_R01Filter({ warehouseCd: v === "all" ? "" : v, })
                    }
                    />

                {/* 브랜드 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={WMS2011_R01Filter.brandCd}
                    optionList={brandCdList}
                    onChangeValue={(v) =>
                        setWMS2011_R01Filter({ brandCd: v === "all" ? "" : v, })
                    }
                />

                {/* 품목그룹 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="품목그룹"
                    value={WMS2011_R01Filter.itemGroup}
                    optionList={itemGroupList}
                    onChangeValue={(v) =>
                        setWMS2011_R01Filter({ itemGroup: v === "all" ? "" : v, })
                    }
                />

                {/* 품목 검색 */}
                <SearchCodeModalForm
                    label="품목코드"
                    value={WMS2011_R01Filter.itemCd}
                    valueLabel={WMS2011_R01Filter.itemNm}
                    handleFoucsId="itemCd_search"
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
                />

                {/* 소계 컨트롤 */}
                <SubtotalControl />
            </SearchSectionDoubleForm>
        </div>
    );
};
